// `store {composition}` (aldoo-na/store/actions/composition.js): what the
// Composition tab needs to know of the parts an outfit names.
import { api } from "aldoo-ra/API"

const storeAPI = api("store")

/** The parts by pid, one request: [{ pid, name, thumbnail, available, amount, currency, discountPercent?, composition, options }]. */
export const loadParts = async (pids, language = "en") => {
  if (!pids.length) return []
  const res = await storeAPI({ composition: { op: "parts", pids, language } })
  if (res?.error) throw new Error(res.error)
  return Array.isArray(res?.parts) ? res.parts : []
}
